export class Orgstyle {
    organizationId:string;
    whitelabelId:string;


    taskcustomerbg?:string;
    taskvendorbg?:string;
    taskmytaskbg?:string;
    taskdonebg?:string;
    tasktextcolor?:string;

    
    topnavnmenuweight?:string;
    topnavmenuweightactive?:string;
    topnavmenufont?:string;
    topnavmenusize?:string;
    topnavmenuiconcolor?:string;
    topnavmenuiconbg?:string;
    topnavmenuiconcolorhover?:string;
    topnavmenuiconbghover?:string;
    topnavnmenuborderbottom?:string;
    
    notificationbgcolor?:string;
    notificationtitlecolor?:string;
    notificationdescriptioncolor?:string;

    pagetitlefont?:string;
    pagetitlesize?:string;
    pagetitleweight?:string;
    pagetitlecolor?:string;
    pagetitlesubfont?:string;
    pagetitlesubsize?:string;
    pagetitlesubweight?:string;
    pagetitlesubcolor?:string;

    portaliconcolor?:string;
    portaliconcolorhover?:string;
    portaliconbg?:string;
    portaliconbghover?:string;
    
    taskanimation?:string;

    footernaviconcolor?:string;
    footernaviconcolorhover?:string;
    footernaviconbg?:string;
    footernaviconbghover?:string;


    mainColor:string;
    negMainColor:string;
    borderRad:string;
    orgFont:string;
    orgContentFont:string;
    orgFontColor:string;
    buttontextColor:string;
    orgBrandWeight:string;
    brandControl:string;
    logoformat:string;
    sidenav:string;
    orgfavicon:string;
    buttonbgcolor:string;
    buttonbghovercolor:string;
    orgtitlecolor:string;
    navborder:string;
    orgiconColor:string;
    buttontextHoverColor:string;
    orgiconhoverColor:string;
    dropdowntextcolor:string;
    tabletextcolor:string;
    plannerdaycolor:string;
    customerpagelabelcolor:string;
    infopinhoverbgcolor:string;
    infopinbgcolor:string;
    footertextcolor:string;
}